import { selectorIcon } from "../../../assets/icons";

const ColorPicker = ({ name, value, handleChange }) => {
  return (
    <div className="form-control relative bg-white flex items-center px-3 cursor-pointer">
      <input
        className="absolute top-0 left-0 h-full w-full opacity-0"
        type="color"
        name={name}
        value={value}
        onChange={handleChange}
      />
      <div
        className="w-2 h-2 rounded-full mr-3"
        style={{ backgroundColor: `${value}` }}
      ></div>
      <span className="text-gray-900">{value}</span>
      <div className="ml-auto">
        <img src={selectorIcon} className="w-5" alt="color selector" />
      </div>
    </div>
  );
};

export default ColorPicker;
